module.exports = __webpack_public_path__ + "img/icon-white-3.f4d27ec9.svg";